const o = (e) => ({
  position: "absolute",
  right: e ? 0 : 8,
  top: "50%",
  transform: "translateY(-50%)",
  color: e ? "#878787" : "#5B5B5B",
  width: e ? 18 : 24,
  height: e ? 18 : 24,
  pointerEvents: "none"
}), t = {
  /** `Menu` Paper: list padding reset matches Select `MenuProps.sx` on the list root. */
  menuPaper: {
    borderRadius: "8px",
    border: "1px solid #EFEFEF",
    marginTop: "4px",
    maxWidth: "min(100vw - 16px, 480px)",
    "& .MuiList-root": {
      padding: "0px"
    }
  },
  /** Search field row at top of the panel (legacy `.input`). */
  searchRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    margin: "8px",
    padding: "6px 8px 6px 12px",
    border: "1px solid #EFEFEF",
    borderRadius: "8px",
    boxSizing: "border-box",
    fontSize: "12px",
    lineHeight: "24px",
    backgroundColor: "#FFFFFF",
    "& input": {
      width: "100%",
      border: "none",
      outline: "none",
      fontSize: "12px",
      lineHeight: "24px",
      color: "#5B5B5B",
      backgroundColor: "transparent"
    }
  },
  /** Search icon at end of the search row. */
  searchIcon: {
    fontSize: "20px",
    color: "#878787",
    flexShrink: 0
  },
  /**
   * Scrollable options region (legacy `.options` under `.menu`).
   * Thin scrollbar: `scrollbarWidth: thin` (Firefox); WebKit uses 2px like the old module.
   */
  optionsScroll: {
    borderTop: "1px solid #EBEBEB",
    maxHeight: "300px",
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "#C4C4C4 transparent",
    "&::-webkit-scrollbar": {
      width: 2,
      height: 2
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#C4C4C4",
      borderRadius: "2px"
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent"
    }
  },
  /** One dropdown row (legacy `.option`). */
  optionRow: {
    padding: "8px 16px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "12px",
    fontWeight: 400,
    color: "#5B5B5B",
    "&:hover": {
      backgroundColor: "#FAFAFA"
    }
  },
  /** Selected row (legacy `.option.selected`). */
  optionRowSelected: {
    backgroundColor: "#EEF9F6"
  },
  compactCheckbox: {
    p: 0
  },
  /** Disabled row state. */
  optionRowDisabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  /** Closed control: single-line value (legacy `.valueText`). */
  valueText: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    minWidth: 0,
    flex: 1,
    overflow: "hidden",
    lineHeight: "24px"
  },
  /** Single-line value label inside the `clearable` trigger. */
  valueLabel: {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "24px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
    m: 0,
    p: 0
  },
  /** Multi-select chip text. */
  chipText: {
    fontSize: "12px",
    fontWeight: 400
  },
  /** Placeholder color when no value is selected. */
  placeholderText: (e) => ({
    color: e.vars?.palette.grey[500] ?? e.palette.grey[500]
  }),
  /** Single-select `clearable` trigger: 4px vertical padding, content centered in 32px min height. */
  clearableTrigger: {
    paddingTop: "4px",
    paddingBottom: "4px",
    height: "auto",
    minHeight: "32px",
    alignItems: "center"
  },
  /** Clear + chevron cluster at the end of the single-select trigger. */
  triggerActions: {
    display: "inline-flex",
    alignItems: "center",
    alignSelf: "center",
    flexShrink: 0,
    marginLeft: "auto",
    gap: "0px",
    height: "24px"
  },
  clearIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 20,
    height: 20,
    fontSize: 18,
    color: "#5B5B5B",
    cursor: "pointer",
    flexShrink: 0,
    "&:hover": {
      color: "#333333"
    }
  },
  chevronIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    fontSize: 24,
    color: "#5B5B5B",
    flexShrink: 0,
    pointerEvents: "none"
  },
  chevronIconNone: {
    fontSize: 20,
    color: "#878787"
  },
  /** `variant="none"`: allow label to wrap (legacy `.value-none .valueText`). */
  valueTextWrap: {
    flexWrap: "wrap",
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "unset"
  },
  /** Multi-select: chip stack in the trigger (legacy `.multiChips`). */
  multiChips: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    alignItems: "center",
    minWidth: 0,
    flex: 1
  },
  /** Multi-select: one chip (legacy `.chip`). */
  chip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "2px 10px",
    borderRadius: "8px",
    border: "1px solid #D7EEE8",
    backgroundColor: "#EEF9F6",
    fontSize: "12px",
    fontWeight: 400,
    color: "#5B5B5B",
    maxWidth: "100%"
  },
  /** Optional leading icon in trigger / row (legacy `.icon`). */
  startIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 24,
    height: 24,
    lineHeight: 0,
    "& svg": {
      fontSize: "18px",
      color: "#5B5B5B",
      display: "block"
    }
  },
  /** No options / empty filter — copy aligned with Select empty `MenuItem`. */
  emptyState: {
    padding: "8px 16px",
    fontSize: "12px",
    fontWeight: 400,
    color: "#878787",
    opacity: 1
  }
};
export {
  o as getSearchSelectorChevronSx,
  t as searchSelectorStyles
};
